import { useLayoutEffect } from 'react';

const useWindowResize = (callback) => {
  useLayoutEffect(() => {
    window.addEventListener('resize', callback);

    return () => {
      window.removeEventListener('resize', callback);
    };
  }, [callback]);
};

export default useWindowResize;